/* eslint-disable react-refresh/only-export-components */
import type { ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from './AuthProvider';
import { ThemeProvider } from './ThemeProvider';
import { VoiceProvider } from '@/features/communities/voice/VoiceProvider';

/** Single composition point for every app-wide provider. */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <AuthProvider>
        <ThemeProvider>
          <VoiceProvider>{children}</VoiceProvider>
        </ThemeProvider>
      </AuthProvider>
    </QueryProvider>
  );
}

export { useAuth } from './AuthProvider';
